import { request } from "../lib/requestHelper";

export const placeBidService = async ({
  postId,
  amount,
  timeline,
  message,
  clientId,
  clientAuthId
}) => {
  if (!amount || !timeline) {
    throw new Error("Amount and timeline are required");
  }

  return await request("artisan/place-bid", {
    method: "POST",
    body: JSON.stringify({
      post_id: postId,
      amount,
      timeline,
      message,
      clientId,
      clientAuthId
    }),
  });
};
